import axiosInstance from "../../axiosInstance";

const BASE_URL = "/elearning/lessons";

export const getAllLessons = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching all lessons:", error);
    throw error;
  }
};

export const getLessonCourses = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/courses`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching lesson courses:", error);
    throw error;
  }
};

export const getLessonById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

export const createLesson = async (lessonData) => {
  const response = await axiosInstance.post(BASE_URL, lessonData);
  return response.data;
};

export const updateLesson = async (id, lessonData) => {
  const response = await axiosInstance.put(`${BASE_URL}/${id}`, lessonData);
  return response.data;
};

export const deleteLesson = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

/** Nhập danh sách bài học (metadata) cho 1 khóa học — chưa cần tài liệu */
export const importLessonsFromExcel = async (file, courseId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("course_id", courseId);
  const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
